import React, {useContext } from "react";
import styled from "styled-components";
import { TbBrandYoutubeKids } from "react-icons/tb"
import { Link } from "react-router-dom";
import Select from "react-select";
import {languages} from "../../utils/constant";
import {customStyles} from "../../utils/style";
import { LanguageContext } from "../../components/LanguageContext"

const Header = () => {

    // Language option //      
  const { language, changeLanguage } = useContext(LanguageContext);            
  const selectedOption = languages.find((option) => option.value === language);
  const handleChange = (selectedOption) => {changeLanguage(selectedOption.value)}

  return (
    <HeaderStyled>
      <>
                      <div className="imgDiv">
                        <img src="/images/logo.png" alt="Kidz Mania" className="imgHeader"/>
                      </div>
                      <div className="extDiv"></div>
                      <div className="langDiv">                            
                             <Select
                            menuPlacement="top"
                            value={selectedOption}
                            options={languages}
                            onChange={handleChange}
                            styles={customStyles}
                            placeholder="Select Language"
                          />    
                      </div>  
                  </>
      
      {/* <Link to="/redirect">
        <h1><span><TbBrandYoutubeKids /></span>KIDZ MANIA</h1>
      </Link> */}
    </HeaderStyled>
  );
};

export default Header;

const HeaderStyled = styled.div`
  min-height: 7vh;
  min-width: 100%;
  background-image: linear-gradient(135deg, #304352 10%, #130cb7 100%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: left;
  h1{
    font-family: 'Pacifico', cursive;
    color: #76b852;
    margin-top: 10px;
    /* font-family: 'Space Mono', monospace; */
    font-weight: 800;
  }
  .langDiv{
    justify-content: center;
    align-items: right;
    padding-top: 10px;
    width:30%;
     width:160px;
  }
  .imgDiv{
    width:30%;
    padding-top: 10px;
   }
    .extDiv{
     width:40%
    }
  
   .imgHeader {
    height: 50px;
    width: 120px;
  }
  .menu-icon {
    position: absolute;
    left: 10px;
    font-size: 30px;
    font-weight: 800;
    z-index: 10;
  }
`;
